export function SearchResult({ title, type, subtype, link = '#', summary }) {
  return /* html */ `
    <li class="c-nav-search-content-li"> 
      <a href="${link}" class="c-nav-search-content-a" onclick="window.closeSearch()">
        <span class="c-tag c-tag--2">${subtype ?? type}</span>
        <h3 class="ts-6">${title}</h3>
        <span class="ts-p">${summary}</span>
	      <a class="c-link">
          <span class="c-link-icon">
            <svg class="icon-r-md" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.46967 0.46967C0.762563 0.176777 1.23744 0.176777 1.53033 0.46967L5.53033 4.46967C5.82322 4.76256 5.82322 5.23744 5.53033 5.53033L1.53033 9.53033C1.23744 9.82322 0.762563 9.82322 0.46967 9.53033C0.176777 9.23744 0.176777 8.76256 0.46967 8.46967L3.93934 5L0.46967 1.53033C0.176777 1.23744 0.176777 0.762563 0.46967 0.46967Z"
                fill="currentColor" />
            </svg>
          </span>
        </a>
      </a>
    </li>`
}
